// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminNetwork_wrapper__BvBGA","container":"AdminNetwork_container__x+5gL"};